// Copyright (c) Docugami, Inc. All rights reserved.

export type IAuthAccessor = {
    getOrganizationId(): string;
    setOrganizationId(fetch: () => string): void;
    getAccessToken(): Promise<string>;
    setAccessToken(fetch: () => Promise<string>): void;
}

let getOrganizationId: () => string = () => '';
let getAccessToken: () => Promise<string> = () => Promise.resolve('');
export const authAccessor: IAuthAccessor = {
    getOrganizationId: () => getOrganizationId(),
    setOrganizationId: fetch => { getOrganizationId = fetch},
    getAccessToken: async () => getAccessToken(),
    setAccessToken: fetch => { getAccessToken = fetch }
};
